__turbopack_context__.v({
  "disabled": "_6BTTRW_disabled",
  "headerListItem": "_6BTTRW_headerListItem",
  "heading": "_6BTTRW_heading",
  "iconWrapper": "_6BTTRW_iconWrapper",
  "perYear": "_6BTTRW_perYear",
  "planTitle": "_6BTTRW_planTitle",
  "price": "_6BTTRW_price",
  "priceRow": "_6BTTRW_priceRow",
  "root": "_6BTTRW_root",
  "subtitle": "_6BTTRW_subtitle",
  "tableWrapper": "_6BTTRW_tableWrapper",
});
